import { SameSupplierBookings } from "./same-supplier-bookings";

type PastBookingsProps = {
  supplier?: {
    id: string;
    name: string;
    no: string;
  };
  account?: {
    id: string;
    name: string;
    no: string;
  };
  lineItemId?: string;
  invoiceId?: string;
  width: number;
};

export const PastBookings = ({
  account,
  supplier,
  lineItemId,
  invoiceId,
  width,
}: PastBookingsProps) => {
  return (
    <div className="flex h-full w-full">
      <div className="flex flex-1 h-full">
        <div className="flex flex-1 flex-col gap-6 pb-4">
          {supplier && (
            <SameSupplierBookings
              supplierName={supplier.name}
              supplierId={supplier.id}
              supplierNo={supplier.no}
            />
          )}
          {/* TODO: We are going to disable this for now, we think is not needed anymore */}
          {/* {account && lineItemId && (
            <SameAccountBookings
              accountId={account.id}
              accountName={account.name}
              accountNo={account.no}
              lineItemId={lineItemId}
            />
          )} */}
        </div>
      </div>
    </div>
  );
};
